<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h5 class="m-0 font-weight-bold text-primary">{{ 'reservation-group-configuration' | translate }}</h5>
    </div>
    <div class="card-body">
        <app-dnd-group-categories *ngIf="categories && categoryGroups" [categories]="categories" [initialCategoryGroups]="categoryGroups" (categoryGroupsToEmit)="setReservationCategoryGroups($event)">
        </app-dnd-group-categories>
    </div>
</div>